import React, { PropsWithChildren, ReactNode } from "react";

import useGeneratedId from "../../../../../shared/hooks/useGeneratedId";
import styles from "./styles.module.scss";

interface SegmentOption<T extends string> {
  label: string;
  id: T;
}

export default function SegmentedController<T extends string>({
  label,
  visuallyHideLabel,
  options,
  value,
  onChange,
  className,
}: {
  label: ReactNode;
  visuallyHideLabel?: boolean;
  options: Readonly<SegmentOption<T>[]>;
  value: T | null;
  onChange: (value: T) => void;
  className?: string;
}) {
  const groupId = useGeneratedId();

  return (
    <fieldset className={`${styles.SegmentedControl} ${className ?? ""}`}>
      <legend className={visuallyHideLabel ? styles.Hidden : ""}>{label}</legend>
      <div className={styles.Options}>
        {options.map(({ label, id, ...option }) => (
          <Segment key={id} groupId={groupId} {...option} checked={id === value} onClick={() => onChange(id)}>
            {label}
          </Segment>
        ))}
      </div>
    </fieldset>
  );
}

function Segment({
  groupId,
  children,
  checked,
  onClick,
}: PropsWithChildren<{
  groupId?: string;
  checked: boolean;
  onClick: () => void;
}>) {
  return (
    <label className={`${styles.Segment} ${checked ? styles.Checked : ""}`}>
      <input name={groupId} type="radio" checked={checked} onChange={onClick} required />

      <span>{children}</span>
    </label>
  );
}
